import React, { Component } from "react";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';
import 'moment/locale/es';
import ReactTooltip from "react-tooltip";

var fechaInput = undefined;
export default class CampoFecha extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: props.name,
      size: props.size,
      title: props.title,
      hidden: props.hidden,
      editable: props.editable,
      type: props.type,
      label: props.label,
      minValue: props.minValue,
      maxValue: props.maxValue,
      minLength: props.minLength,
      maxLenght: props.maxLenght,
      required: props.required,
      nullable: props.nullable,
      debitable: props.debitable,
      format: props.format,
      date: "",
      isInvalid: false,
      isRequired: false,
      selectedOption: undefined
    }
  };
  componentDidMount() {
  }

  handleChange = (e) => {
    let fecha=formatDate(e, 'DD-MM-YYYY');
    let fechaHoy = formatDate(new Date(), 'DD-MM-YYYY')

    if(fecha > fechaHoy) {
      this.setState({isInvalid: true});
      return undefined;
    }

    if (formatDate(e, "YYYY") < "1900") {
      this.setState({isInvalid: true});
      return undefined;
    }

    this.setState({isInvalid: false});
    //this.props.inputValue(fecha, this.state.name, false, "","DATE");
    return fecha;
  };



  render() {
    const FORMAT = 'DD/MM/yyyy';
    return (
      <div>
        <div className="input-group">
          <DayPickerInput
            name="fechaNacimiento"
            ref={(a) => (this.dateSelect = a)}
            formatDate={formatDate}
            parseDate={parseDate}
            format={FORMAT}
            placeholder={'DD/MM/AAAA'}
            dayPickerProps={{
              locale: 'es',
              localeUtils: MomentLocaleUtils,
            }}
            inputProps={{
              //readonly: 'readonly',
              className: "input-box form-control form-fecha",
              required: this.state.required
            }}
            onDayChange={(selectedDay) => { 
              fechaInput = selectedDay
              if(selectedDay!==undefined){
                this.setState({isRequired: false});
                this.props.onChange(this.handleChange(selectedDay));
              } else {
                this.props.onChange(undefined);
                this.setState({isRequired: true});
              }
              this.setState({selectedOption: selectedDay}, () => {
              })
            }}
            onDayPickerHide={() => {
              if(fechaInput===undefined){
                ///// borrar contenido campo fecha
                this.dateSelect.input.defaultValue = ""
                this.dateSelect.input.value = ""
                this.dateSelect.state.value = ""
                this.dateSelect.state.typedValue = ""
              }
              
            }}
            style={{ width: "calc(100% - 39.13px)"}}
            className={this.state.isInvalid && "invalid-select-border"}
          />
          <div className="input-group-append">
            <span className="input-group-text input-box"><i className="far fa-calendar-alt"></i></span>
          </div>
          {(!this.state.isInvalid) && this.state.isRequired && (
                <span className="invalid-select">Este campo es requerido</span>
          )}
          {this.state.isInvalid && (
                <span className="invalid-select">Esta fecha es inválida</span>
          )}
        </div>
        <ReactTooltip/>
      </div>
    );
  }
}

